import styled from 'styled-components';
// import FlameIconSvg from '../../stories/assets/hotels/amenities/'
import FlameIconSvg from '../assets/hotels/home/flame.svg';

const FlameIcon = styled(FlameIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.goRed.base};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default FlameIcon;
